import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingDown } from 'lucide-react';

interface VarianceWeekMiniCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function VarianceWeekMiniCardThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: VarianceWeekMiniCardThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm border-amber-200 bg-amber-50/50">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Variance This Week
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-1">
            <div className="flex items-center justify-between text-xs">
              <span className="text-muted-foreground">Forecasted:</span>
              <span className="font-semibold">£52,000</span>
            </div>
            <div className="flex items-center justify-between text-xs">
              <span className="text-muted-foreground">Actual:</span>
              <span className="font-semibold">£48,500</span>
            </div>
            <div className="flex items-center justify-between text-xs pt-1 border-t">
              <span className="text-muted-foreground">Variance:</span>
              <div className="flex items-center gap-1">
                <TrendingDown className="h-3 w-3 text-red-500" />
                <span className="font-bold text-red-500">-6.7%</span>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
